module.exports = __webpack_public_path__ + "img/upload.75d53478.svg";